import { useQuery } from '@tanstack/react-query';
import { visitTimelineService } from '../visitTimelineService';

export function useVisitTimelineByVisit(visitId?: string) {
  return useQuery({
    queryKey: ['visitTimeline', 'visit', visitId],
    queryFn: () => visitTimelineService.getByVisit(visitId!),
    enabled: !!visitId,
    staleTime: 30000,
  });
}

export function useVisitTimelineByPatient(patientId?: string, page = 1, limit = 50) {
  return useQuery({
    queryKey: ['visitTimeline', 'patient', patientId, page, limit],
    queryFn: () => visitTimelineService.getByPatient(patientId!, page, limit),
    placeholderData: (previous) => previous,
    enabled: !!patientId,
    staleTime: 30000,
  });
}
